import { render, staticRenderFns } from "./ClassItemUsersView.vue?vue&type=template&id=d387d7ec"
import script from "./ClassItemUsersView.vue?vue&type=script&lang=js"
export * from "./ClassItemUsersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports